<template>
    <div class="relative inline-block text-left" ref="dropdown">
        <div @click="open = !open">
            <span class="rounded-md shadow-sm">
                <button
                    type="button"
                    class="relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
                    id="options-menu"
                    aria-haspopup="true"
                    aria-expanded="true"
                >
                    <slot name="text"></slot>
                    <svg class="-mr-1 ml-2 h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path
                            fill-rule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </button>
            </span>
        </div>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <!--            <div class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg" v-if="open">-->
            <div class="origin-top-left absolute left-0 mt-2 w-56 rounded-md shadow-lg z-10" v-if="open">
                <div class="rounded-md bg-white ring-1 ring-black ring-opacity-5">
                    <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                        <slot name="content"></slot>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script setup>
import { ref } from 'vue';
import { onClickOutside, onKeyDown } from '@vueuse/core';

const open = ref(false);

const dropdown = ref(null);

const close = () => (open.value = false);
onClickOutside(dropdown, () => close());
onKeyDown(['Escape'], () => close());
</script>
